import { render, staticRenderFns } from "./estatisticas.vue?vue&type=template&id=1db43a2a&scoped=true"
import script from "./estatisticas.vue?vue&type=script&lang=js"
export * from "./estatisticas.vue?vue&type=script&lang=js"
import style0 from "./estatisticas.vue?vue&type=style&index=0&id=1db43a2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db43a2a",
  null
  
)

export default component.exports